













export default {
  props: {
    empty: { type: Boolean, required: true },
    loading: { type: Boolean, default: false }
  }
}
